export const SESSION_EXPIRED = 'Session expired please log in again.';

export const CLAIM_NO_CONTACT_INFO_MESSAGE = 'Cannot claim invite code because profile has no details.';
export const CLAIM_INVALID_INVITE_CODE_MESSAGE = 'Invalid invite code.';
export const CLAIM_NOT_CLAIMED_MESSAGE = 'Invite code not claimed.';
export const CLAIM_RECENT_VERIFICATION_MESSAGE = 'Requested code recently. Please wait for 1 minute after the last request.';
export const CLAIM_CLAIM_FAILED_MESSAGE = 'Invite code not claimed failed.';
export const CLAIM_ALREADY_CLAIMED_MESSAGE = 'Invite code already claimed.';
